export default __webpack_public_path__ + "static/media/notfound.c4cc7d0b.svg";